<script>
import { Doughnut } from 'vue-chartjs'
import { graphRatingColours, ratingLabels, ratingArray } from './ratings'
import {
  GET_LIST_OF_STUDENTS_FOR_ENGAGEMENT, GET_LATEST_ENGAGEMENT_COUNT
} from '../../store/action-types'
import { mapState, mapActions } from 'vuex'

function setupGraphData (self, studentRatingCounts) {
  return {
    data: {
      labels: ratingLabels,
      datasets: [
        {
          backgroundColor: graphRatingColours,
          data: studentRatingCounts
        }
      ]
    },
    options: {
      animation: {
        animateScale: true
      },
      cutoutPercentage: 70,
      responsive: true,
      maintainAspectRatio: true,
      onClick (event, chartElement) {
        if (chartElement.length) {
          self.showStudents(chartElement[0]._index)
        }
      },
      legend: {
        display: false
      },
      tooltips: {
        callbacks: {
          label: (model, chart) => {
            const label = ratingLabels[model.index]
            const count = chart.datasets[0].data[model.index]
            return self.$t('dashboard.ratings.' + label) + ' : ' + count
          }
        }
      }
    }
  }
}

export default {
  extends: Doughnut,
  name: 'dashboard-engagement-graph',
  methods: {
    ...mapActions({
      getLatestEngagementCount: GET_LATEST_ENGAGEMENT_COUNT
    }),
    showStudents (engagementIndex) {
      this.$store.dispatch(GET_LIST_OF_STUDENTS_FOR_ENGAGEMENT, ratingArray[engagementIndex])
      this.$router.push({name: 'Students'})
    }
  },
  computed: {
    ...mapState({
      studentRatingCounts: state => state.dashboard.studentRatingCounts
    })
  },
  watch: {
    studentRatingCounts (value) {
      // Data has updated
      if (this.$data._chart) {
        this.$data._chart.destroy()
      }
      let {data, options} = setupGraphData(this, this.studentRatingCounts)
      this.renderChart(data, options)
    }
  },
  mounted () {
    this.getLatestEngagementCount()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardEngagementGraph.vue